<template>
  <div v-if="show" class="fixed left-0 top-0 w-full h-full flex justify-center items-center bg-[rgba(0,0,0,0.4)] z-[10000] p-2">
    <div class="bg-[#fff] rounded border border-[#D1D1D1] p-2">
      <div class="flex justify-end">
        <div class="cursor-pointer" @click="handleClose">
          <i class="ri-close-line text-xl text-[#000]"></i>
        </div>
      </div>
      <div class="text-center px-4">
        <div class="flex items-center justify-center pb-3">
            <i class="ri-checkbox-circle-fill text-3xl text-[#248726]"></i>
        </div>
        
        <!-- Success Message -->
        <div class="space-y-6">
          <h2 class="text-[26px] font-semibold text-[#464646]">{{ t('propertyReport.success.title') }}</h2>
          <div class="text-base text-[#464646]">
            <p>{{ t('propertyReport.success.description1') }}</p>
            <p>{{ t('propertyReport.success.description2') }}</p>
          </div>
          <div>
            <p class="text-base font-bold text-[#464646]">{{ t('propertyReport.success.confirmationNumber', { id: transactionId }) }}</p>
          </div>
        </div>
        
        <!-- Action Buttons -->
        <div class="flex flex-col sm:flex-row items-center justify-center gap-3 pt-3 pb-4">
          <button 
            @click="copyConfirmationNumber" 
            class="flex items-center gap-1 px-2 py-1.5 text-base text-[#171717] border border-[#B9B9B9] rounded"
          >
            <i class="ri-file-copy-line text-xl text-[#464646]"></i>
            {{ t('propertyReport.success.copyConfirmationNumber') }}
          </button>
          <button 
            class="bg-[#762123] text-[#fff] rounded px-3 py-2 text-base font-medium" 
            @click="handleDone"
          >
            {{ t('propertyReport.success.done') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { getLanguage } from '@/utilities/cookies'

const { t, locale } = useI18n()
locale.value = getLanguage()

const props = defineProps({
  show: { type: Boolean, default: false },
  transactionId: { type: String, default: '' }
})

const emit = defineEmits(['done', 'close'])

function handleDone() {
  emit('done')
  window.location.href = '/property-reports'
}

function handleClose() {
  emit('close')
}

function copyConfirmationNumber() {
  if (props.transactionId) {
    navigator.clipboard.writeText(props.transactionId).then(() => {
      if (typeof window.toastr !== 'undefined') {
        window.toastr.success(t('propertyReport.success.confirmationCopied'))
      }
    }).catch(() => {
      if (typeof window.toastr !== 'undefined') {
        window.toastr.error('Failed to copy confirmation number')
      }
    })
  }
}
</script>
